import connectors from '@/router/routes/settings/connectors'
import kkmServer from '@/router/routes/settings/kkmServer'
import paymentMethods from '@/router/routes/settings/paymentMethods'
import printingFiscal from '@/router/routes/settings/printingFiscal'
import orders from '@/router/routes/settings/orders'
import qrFeedback from '@/router/routes/settings/qrFeedback'
import reviewActions from '@/router/routes/settings/reviewActions'
import seoPageMeta from '@/router/routes/settings/seoPageMeta'
import sources from '@/router/routes/settings/sources'
import legalInfoPages from '@/router/routes/settings/legalInfoPages'
import CRMPermission from '@/models/enums/permissions/CRMPermission'
import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/settings',
    name: RouteName.Settings,
    component: () => import('@/pages/Settings/SettingsPage.vue'),
    meta: {
      permissions: [CRMPermission.ViewSettings],
      breadcrumb: {
        label: 'Настройки',
        parent: 'Главная',
      },
    },
  },
  ...kkmServer,
  ...seoPageMeta,
  ...connectors,
  ...sources,
  ...legalInfoPages,
  ...paymentMethods,
  ...printingFiscal,
  ...orders,
  ...qrFeedback,
  ...reviewActions,
]
